import { useCallback, useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import {
  trunkCreateNewMeeting,
  trunkDeleteMeeting,
  trunkGetMeetingDetail,
  trunkGetMeetingList,
  trunkGetMeetingListBySearchKeyword,
  trunkGetZoomDetailWithDiff,
  trunkMeetingFavorite,
  trunkUpdateMeeting,
} from "../store/meeting";
import {
  MeetingRequest,
  SetMeetingFavoriteRequest,
  updateMeetingEntity,
  ZoomRequestDto,
} from "../../types/meeting";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useMeetingStore = () => {
  const meetingState = useRootState((state) => state.meetingStore);

  const dispatch = useAppDispatch();

  const boundGetMeetingDetail = useCallback(
    (req: { workgroupId: string; meetingId: string; occurrenceId?: string }) =>
      dispatch(trunkGetMeetingDetail(req)).then(),
    [dispatch]
  );
  const boundGetMeetingList = useCallback(
    (req: { workgroupId: string; zoomDto: ZoomRequestDto }) =>
      dispatch(trunkGetMeetingList(req)).then(),
    [dispatch]
  );
  const boundGetZoomDetailWithDiff = useCallback(
    (req: { workgroupId: string; meetingId: string; occurrenceId?: string }) =>
      dispatch(trunkGetZoomDetailWithDiff(req)).then(),
    [dispatch]
  );
  const boundMeetingFavorite = useCallback(
    (req: SetMeetingFavoriteRequest) =>
      dispatch(trunkMeetingFavorite(req)).then(),
    [dispatch]
  );
  const boundGetMeetingListBySearchKeyword = useCallback(
    (reqDTO: MeetingRequest) =>
      dispatch(trunkGetMeetingListBySearchKeyword(reqDTO)).then(),
    [dispatch]
  );
  const boundNewMeeting = useCallback(
    (reqDTO: updateMeetingEntity) =>
      dispatch(trunkCreateNewMeeting(reqDTO)).then(),
    [dispatch]
  );
  const boundUpdateMeeting = useCallback(
    (reqDTO: updateMeetingEntity) =>
      dispatch(trunkUpdateMeeting(reqDTO)).then(),
    [dispatch]
  );
  const boundDeleteMeeting = useCallback(
    (reqDTO: updateMeetingEntity) =>
      dispatch(trunkDeleteMeeting(reqDTO)).then(),
    [dispatch]
  );
  return {
    meetingState,
    getmeetingList: boundGetMeetingList,
    getMeetingDetail: boundGetMeetingDetail,
    getZoomDetailWithDiff: boundGetZoomDetailWithDiff,
    setZoomMeetingFavorite: boundMeetingFavorite,
    getMeetingListBySearchKeyword: boundGetMeetingListBySearchKeyword,
    createNewMeeting: boundNewMeeting,
    updateMeeting: boundUpdateMeeting,
    deleteMeeting: boundDeleteMeeting,
  };
};

export default useMeetingStore;
